namespace Portico.Models.Enterprise {

    export interface ILayoutSection {
        id: number;
        layoutId: number;
        entityName: string;
        configurationDetails: string[];
        questions: LayoutSectionQuestion[];
        entityId: number;
        name: string;
        description: string;
        sequence: number;
        visited: boolean;
    }

    export class LayoutSection implements ILayoutSection {
        id: number;
        layoutId: number;
        entityName: string;
        configurationDetails: string[];
        questions: LayoutSectionQuestion[];
        entityId: number;
        name: string;
        description: string;
        sequence: number;
        visited: boolean;

        constructor(obj?: ILayoutSection | any) {
            this.id = null;
            this.layoutId = null;
            this.entityName = null;
            this.configurationDetails = [];
            this.questions = [];
            this.entityId = null;
            this.name = null;
            this.description = null;
            this.sequence = null;
            this.visited = false;

            if (obj) {
                this.id = obj.id;
                this.layoutId = obj.layoutId;
				this.entityName = obj.entityName;

				if (obj.configurationDetails) {
					for (const configurationDetail of obj.configurationDetails) {
                        this.configurationDetails.push(configurationDetail);
                    }
                }

                if (obj.questions) {
					for (const question of obj.questions) {
                        this.questions.push(new LayoutSectionQuestion(question));
                    }
                }

				this.entityId = obj.entityId;
                this.name = obj.name;
                this.description = obj.description;
                this.sequence = obj.sequence;
                this.visited = obj.visited;
            }
        }
    }
}